import { AnyAction } from 'redux';
import { GoogleAdsType } from 'domain/types/googleAds.type';
import { GoogleAdsReducerType } from 'model/reducers/GoogleAdsReducerType';

const initialState: GoogleAdsReducerType = {
  filters: {},
  hourlyCoC: null,
  highestCostKeywords: null,
  lowestConvKeywords: null,
  campaigns: [],
  adGroups: [],
  syncStatus: null,
  error: null,
};

const googleAdsReducer = (state = initialState, action: AnyAction): GoogleAdsReducerType => {
  const { type, payload } = action;

  switch (type) {
    case GoogleAdsType.SET_FILTERS:
      return { ...state, filters: payload.filters };

    // Hourly CoC
    case GoogleAdsType.FETCH_HOURLY_COC_REQUEST:
      return { ...state, error: null };
    case GoogleAdsType.FETCH_HOURLY_COC_SUCCESS:
      return { ...state, hourlyCoC: payload.data, error: null };
    case GoogleAdsType.FETCH_HOURLY_COC_FAILURE:
      return { ...state, error: payload.error };

    // Highest Cost Keywords
    case GoogleAdsType.FETCH_HIGHEST_COST_KW_REQUEST:
      return { ...state, error: null };
    case GoogleAdsType.FETCH_HIGHEST_COST_KW_SUCCESS:
      return { ...state, highestCostKeywords: payload.data, error: null };
    case GoogleAdsType.FETCH_HIGHEST_COST_KW_FAILURE:
      return { ...state, error: payload.error };

    // Lowest Conversion Keywords
    case GoogleAdsType.FETCH_LOWEST_CONV_KW_REQUEST:
      return { ...state, error: null };
    case GoogleAdsType.FETCH_LOWEST_CONV_KW_SUCCESS:
      return { ...state, lowestConvKeywords: payload.data, error: null };
    case GoogleAdsType.FETCH_LOWEST_CONV_KW_FAILURE:
      return { ...state, error: payload.error };

    // Campaigns
    case GoogleAdsType.FETCH_CAMPAIGNS_SUCCESS:
      return { ...state, campaigns: payload.campaigns };
    case GoogleAdsType.FETCH_CAMPAIGNS_FAILURE:
      return { ...state, error: payload.error };

    // Ad Groups
    case GoogleAdsType.FETCH_AD_GROUPS_SUCCESS:
      return { ...state, adGroups: payload.adGroups };
    case GoogleAdsType.FETCH_AD_GROUPS_FAILURE:
      return { ...state, error: payload.error };

    // Sync Status
    case GoogleAdsType.FETCH_SYNC_STATUS_SUCCESS:
      return { ...state, syncStatus: payload.status };
    case GoogleAdsType.FETCH_SYNC_STATUS_FAILURE:
      return { ...state, error: payload.error };

    default:
      return state;
  }
};

export default googleAdsReducer;
